const handleTransitionEnd = function(e) {
	if ( ! e.propertyName || e.propertyName !== 'height' ) {
		return;
	}
	this.removeEventListener('transitionend', handleTransitionEnd);
	this.style.height = '';
}

export function slideUp(node, callback = null ) {
	const rect = node.getBoundingClientRect();
	node.style.height = `${rect.height}px`;
	node.addEventListener('transitionend', handleTransitionEnd);

	if ( typeof callback === 'function' ) {
		setTimeout( () => {
			node.style.height = '0px';
			callback();
		}, 10 );
	}
}

export function slideDown( node, callback = null ) {
	node.style.height = 'auto';
	const rect = node.getBoundingClientRect();
	node.style.height = `${rect.height}px`;
	node.addEventListener('transitionend', handleTransitionEnd);

	if ( typeof callback === 'function' ) {
		node.style.height = '0';
		setTimeout( () => {
			node.style.height = `${rect.height}px`;
			callback();
		}, 10 );
	}
}

export default {
	slideUp: slideUp,
	slideDown: slideDown,
}
